import { getIsLoggedIn } from '@api/selectors/auth';
import useFetch from '@hooks/useFetch';
import { HOST_TYPE, getHost } from '@utils/api-helper/host';
import useMyInfo from '../auth/useMyInfo';

const defaultHost = getHost();

const useGetReferralDetails = () => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const key = isLoggedIn
    ? `${defaultHost}v2/subscriptions/referrals/details`
    : null;

  const { data = {}, ...rest } = useFetch(
    key,
    { hostType: HOST_TYPE.BACKEND_API_HOST },
    { useCamelCase: false }
  );
  return { data, ...rest };
};

export default useGetReferralDetails;
